import { Controller } from '@hotwired/stimulus'

/**
 * Turns a single labelled field into a repeatable group: an "Add" button
 * appends another input row cloned from a `<template>`, and each row carries its
 * own remove control. Used on the Associated Person create/edit form for the
 * multi-value fields (aliases, phone numbers, emails, addresses, social media
 * handles). A group may be reduced to zero rows.
 */
export default class MultiInputController extends Controller {
  static targets = ['container', 'template']

  declare readonly containerTarget: HTMLElement
  declare readonly hasContainerTarget: boolean
  declare readonly templateTarget: HTMLTemplateElement
  declare readonly hasTemplateTarget: boolean

  add (): void {
    if (!this.hasContainerTarget || !this.hasTemplateTarget) {
      return
    }

    const row = this.templateTarget.content.cloneNode(true)
    this.containerTarget.appendChild(row)
  }

  remove (event: Event): void {
    const target = event.target

    if (!(target instanceof Element)) {
      return
    }

    target.closest('[data-multi-input-row]')?.remove()
  }
}
